import { useQuery } from "@tanstack/react-query";
import { GET_TASK_EXTENDED_INFO, getTaskExtendedInfo } from "..";

export const useTaskExtendedInfo = ({
  load = false,
  courseTaskId = null,
  studentTaskId = null,
  taskGroup = null,
}) => {
  const enabled = load && !!courseTaskId && !!studentTaskId && !!taskGroup;

  return useQuery({
    queryKey: [GET_TASK_EXTENDED_INFO, courseTaskId, studentTaskId, taskGroup],
    queryFn: () =>
      getTaskExtendedInfo({
        courseTaskId,
        studentTaskId,
        taskGroup,
      }),
    enabled,
  });
};
